var map = {
	"./bs_t-4_reflect-stitch_blk.png": 177469,
	"./bs_t-4_reflect-stitch_blu.png": 221955,
	"./bs_t-4_reflect-stitch_cml.png": 424328,
	"./bs_t-4_reflect-stitch_crk.png": 67574,
	"./bs_t-4_reflect-stitch_grn.png": 321191,
	"./bs_t-4_reflect-stitch_lgd.png": 483481,
	"./bs_t-4_reflect-stitch_lsl.png": 446917,
	"./bs_t-4_reflect-stitch_nvy.png": 341329,
	"./bs_t-4_reflect-stitch_orn.png": 96223,
	"./bs_t-4_reflect-stitch_pnk.png": 592261,
	"./bs_t-4_reflect-stitch_ppl.png": 509444,
	"./bs_t-4_reflect-stitch_red.png": 965077,
	"./bs_t-4_reflect-stitch_sax.png": 214472,
	"./bs_t-4_reflect-stitch_wht.png": 247363,
	"./bs_t-4_reflect-stitch_ylw.png": 262962
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 671996;